import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiConsumer } from '../../service/api-consumer';
import { StatsExport } from '../../interface/request/StatsExport';

export const exportToExcel = createAsyncThunk('export/excel', async (payload: StatsExport) => {
  const response = await ApiConsumer.export(payload);

  return response;
});

interface ExportExcelState {
  data: string[] | null;
  loading: boolean;
  error: unknown | null;
}

const initialState: ExportExcelState = {
  data: null,
  loading: false,
  error: null,
};

const exportSlice = createSlice({
  name: 'exportData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(exportToExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(exportToExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(exportToExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default exportSlice.reducer;
